import { render } from "./ScoreWeb.vue?vue&type=template&id=cda11b08&scoped=true"
import script from "./ScoreWeb.vue?vue&type=script&lang=js"
export * from "./ScoreWeb.vue?vue&type=script&lang=js"

import "./ScoreWeb.vue?vue&type=style&index=0&id=cda11b08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cda11b08"]])

export default __exports__